<template>
  <div class="goods-manage">
    <!-- 搜索与操作区域 -->
    <div class="search-section">
      <div class="search-fields">
        <el-input
            v-model="name"
            placeholder="🔍 搜索物品名"
            suffix-icon="el-icon-search"
            class="search-input"
            clearable
            @keyup.enter.native="loadPost"
        />
        <el-select
            v-model="storage"
            placeholder="选择仓库"
            class="search-select"
            clearable
        >
          <el-option
              v-for="item in storageData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          />
        </el-select>
        <el-select
            v-model="goodstype"
            placeholder="选择分类"
            class="search-select"
            clearable
        >
          <el-option
              v-for="item in goodstypeData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          />
        </el-select>

        <el-date-picker
            v-model="createMonth"
            type="month"
            placeholder="选择创建月份"
            value-format="yyyy-MM"
            class="search-select"
            clearable
        ></el-date-picker>

        <el-button type="primary" icon="el-icon-search" class="action-btn" @click="loadPost">查询</el-button>
        <el-button icon="el-icon-refresh" class="action-btn" @click="resetParam">重置</el-button>

        <!-- 导出按钮 -->
        <el-button
            type="success"
            icon="el-icon-download"
            class="action-btn"
            @click="exportExcel"
        >
          导出Excel
        </el-button>
      </div>
      <div class="action-buttons" v-if="user.roleId != 2">
        <el-button type="success" icon="el-icon-plus" class="action-btn" @click="add">新增</el-button>
        <el-button type="warning" icon="el-icon-bottom" class="action-btn" @click="inGoods">入库</el-button>
        <el-button type="danger" icon="el-icon-top" class="action-btn" @click="outGoods">出库</el-button>
      </div>
    </div>

    <!-- 表格区域 -->
    <el-table
        :data="tableData"
        style="width: 100%; border-radius: 12px; box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);"
        :header-cell-style="{ background: '#f8f9fc', color: '#2c3e50', fontWeight: 600, fontSize: '14px' }"
        border
        highlight-current-row
        @current-change="selectCurrentChange"
        stripe
    >
      <el-table-column label="ID" type="index" width="60" align="center" />
      <el-table-column prop="name" label="物品名" min-width="130" align="center" />
      <el-table-column prop="storage" label="仓库" min-width="120" :formatter="formatStorage" align="center" />
      <el-table-column prop="goodstype" label="分类" min-width="120" :formatter="formatGoodstype" align="center" />
      <el-table-column prop="count" label="采购数量" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.count }} {{ scope.row.unit || '' }}
        </template>
      </el-table-column>
      <el-table-column prop="surplusCount" label="剩余数量" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.surplusCount <= scope.row.warnNum ? 'danger' : 'success'"
              size="small"
          >
            {{ scope.row.surplusCount }} {{ scope.row.unit || '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="80" align="center" />
      <el-table-column prop="totalPrice" label="总金额" min-width="120" align="right" />
      <el-table-column prop="createTime" label="创建时间" min-width="160" :formatter="formatDateTime" align="center" />
      <el-table-column prop="updateTime" label="更新时间" min-width="160" :formatter="formatDateTime" align="center" />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip align="center" />
      <el-table-column
          label="操作"
          v-if="user.roleId != 2"
          fixed="right"
          width="200"
          align="center"
      >
        <template slot-scope="scope">
          <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              plain
              @click="mod(scope.row)"
              style="border-radius: 15px; padding: 1px 8px; font-size: 12px;"
          >编辑</el-button>
          <el-popconfirm title="确定删除该物品吗？" @confirm="del(scope.row.id)">
            <el-button
                slot="reference"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                plain
                v-if="user.roleId !== 1"
                style="border-radius: 15px; padding: 1px 8px; font-size: 12px;"
            >删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
        :title="form.id ? '编辑物品' : '新增物品'"
        :visible.sync="centerDialogVisible"
        width="40%"
        top="5vh"
        center
        :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="90px" size="medium">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="物品名" prop="name">
              <el-input v-model="form.name" placeholder="请输入物品名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库" prop="storage">
              <el-select v-model="form.storage" placeholder="请选择仓库" style="width: 100%">
                <el-option v-for="item in storageData" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分类" prop="goodstype">
              <el-select v-model="form.goodstype" placeholder="请选择分类" style="width: 100%">
                <el-option v-for="item in goodstypeData" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位" prop="unit">
              <el-select
                  v-model="form.unit"
                  placeholder="请选择或输入单位"
                  style="width: 100%"
                  clearable
                  filterable
                  allow-create
              >
                <el-option label="个" value="个" />
                <el-option label="件" value="件" />
                <el-option label="支" value="支" />
                <el-option label="箱" value="箱" />
                <el-option label="套" value="套" />
                <el-option label="瓶" value="瓶" />
                <el-option label="盒" value="盒" />
                <el-option label="台" value="台" />
                <el-option label="张" value="张" />
                <el-option label="包" value="包" />
                <el-option label="千克" value="千克" />
                <el-option label="米" value="米" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- ✅ 只有新增显示单价，修改不显示 -->
            <el-form-item label="单价" prop="price" v-if="!form.id">
              <el-input v-model="form.price" placeholder="请输入单价">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预警库存" prop="warnNum">
              <el-input v-model.number="form.warnNum" placeholder="自定义该物品预警值" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="采购数量" prop="count">
              <el-input v-model="form.count" placeholder="请输入采购数量" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="剩余数量">
              <el-input v-model="form.surplusCount" readonly disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" :rows="3" placeholder="可选备注信息" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save" :loading="saving">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 出入库弹窗 -->
    <el-dialog
        :title="form1.action === '1' ? '入库操作' : '出库操作'"
        :visible.sync="inDialogVisible"
        width="35%"
        top="10vh"
        center
        :close-on-click-modal="false"
    >
      <el-dialog
          width="60%"
          title="选择用户"
          :visible.sync="innerVisible"
          append-to-body
          top="5vh"
      >
        <SelectUser @doSelectUser="doSelectUser" />
        <span slot="footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmUser">确 定</el-button>
        </span>
      </el-dialog>
      <el-form ref="form1" :rules="rules1" :model="form1" label-width="90px" size="medium">
        <el-form-item label="物品名">
          <el-input v-model="form1.goodsname" readonly disabled />
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-select
              v-model="form1.unit"
              placeholder="请选择或输入单位"
              style="width: 100%"
              clearable
              filterable
              allow-create
          >
            <el-option label="个" value="个" />
            <el-option label="件" value="件" />
            <el-option label="支" value="支" />
            <el-option label="箱" value="箱" />
            <el-option label="套" value="套" />
            <el-option label="瓶" value="瓶" />
            <el-option label="盒" value="盒" />
            <el-option label="台" value="台" />
            <el-option label="张" value="张" />
            <el-option label="包" value="包" />
            <el-option label="千克" value="千克" />
            <el-option label="米" value="米" />
          </el-select>
        </el-form-item>

        <!-- 入库显示单价，出库不显示 -->
        <el-form-item label="单价" prop="price" v-if="form1.action === '1'">
          <el-input v-model="form1.price" placeholder="请输入单价">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="申请人">
          <el-input v-model="form1.username" readonly @click.native="selectUser" placeholder="点击选择用户">
            <i slot="suffix" class="el-icon-user" style="cursor: pointer; line-height: 36px; margin-right: 8px;" />
          </el-input>
        </el-form-item>
        <el-form-item label="操作数量" prop="count">
          <el-input v-model="form1.count" placeholder="请输入数量" @input="calcSurplus" />
        </el-form-item>
        <el-form-item label="当前剩余">
          <el-input v-model="form1.surplusCount" readonly disabled>
            <template slot="append">{{ form1.unit || '' }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form1.remark" :rows="3" placeholder="操作备注" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="inDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitStock" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectUser from "../user/SelectUser";
// 导出Excel所需依赖
import * as XLSX from 'xlsx';

export default {
  name: "GoodsManage",
  components: { SelectUser },
  data() {
    const checkCount = (rule, value, callback) => {
      if (value > 9999) callback(new Error("数量输入过大"));
      else callback();
    };
    const checkWarnNum = (rule, value, callback) => {
      if (value < 0) {
        callback(new Error("预警库存不能为负数"));
      } else {
        callback();
      }
    };
    return {
      user: JSON.parse(sessionStorage.getItem("CurUser")),
      storageData: [],
      goodstypeData: [],
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      name: "",
      storage: "",
      goodstype: "",
      createMonth: "",
      centerDialogVisible: false,
      inDialogVisible: false,
      innerVisible: false,
      currentRow: {},
      tempUser: {},
      originCount: 0,
      originSurplus: 0,
      saving: false,
      submitting: false,
      form: {
        id: "",
        name: "",
        storage: "",
        goodstype: "",
        unit: "",
        price: "",
        count: "",
        surplusCount: "",
        totalPrice: "",
        remark: "",
        createTime: "",
        updateTime: "",
        warnNum: 10
      },
      form1: {
        goods: "",
        goodsname: "",
        unit: "",
        count: "",
        surplusCount: "",
        username: "",
        userid: "",
        adminId: "",
        remark: "",
        action: "1",
        price: ""
      },
      rules1: {
        price: [
          { required: true, message: "请输入单价", trigger: "blur" },
          { pattern: /^([1-9]\d*(\.\d+)?|0\.\d*[1-9]\d*)$/, message: "单价必须为正数", trigger: "blur" }
        ],
        count: [
          { required: true, message: "请输入数量", trigger: "blur" },
          { pattern: /^[1-9]\d*$/, message: "数量必须为正整数", trigger: "blur" },
          { validator: checkCount, trigger: "blur" }
        ]
      },
      rules: {
        name: [{ required: true, message: "请输入物品名", trigger: "blur" }],
        storage: [{ required: true, message: "请选择仓库", trigger: "change" }],
        goodstype: [{ required: true, message: "请选择分类", trigger: "change" }],
        unit: [{ required: false }],
        price: [
          { required: true, message: "请输入单价", trigger: "blur" },
          { pattern: /^([1-9]\d*(\.\d+)?|0\.\d*[1-9]\d*)$/, message: "单价必须为正数", trigger: "blur" }
        ],
        count: [
          { required: true, message: "请输入数量", trigger: "blur" },
          { pattern: /^[1-9]\d*$/, message: "数量必须为正整数", trigger: "blur" },
          { validator: checkCount, trigger: "blur" }
        ],
        warnNum: [
          { required: true, message: "请设置物品预警库存", trigger: "blur" },
          { validator: checkWarnNum, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    formatDateTime(row, column, cellValue) {
      if (!cellValue) return "";
      return cellValue.replace("T", " ");
    },
    calcSurplus() {
      let num = Number(this.form1.count) || 0;
      if (num < 0) {
        this.form1.count = 0;
        num = 0;
      }
      if (this.form1.action === "1") {
        this.form1.surplusCount = this.originSurplus + num;
      } else {
        let newSurplus = this.originSurplus - num;
        if (newSurplus < 0) {
          this.$message.warning("库存不足，无法出库");
          this.form1.count = this.originSurplus;
          this.form1.surplusCount = 0;
        } else {
          this.form1.surplusCount = newSurplus;
        }
      }
    },
    submitStock() {
      let num = Number(this.form1.count) || 0;
      if (num <= 0) {
        this.$message.warning("请输入合法操作数量");
        return;
      }
      if (this.form1.action === "2" && num > this.originSurplus) {
        this.$message.error("出库数量不能大于剩余库存");
        return;
      }

      let recordNum = this.form1.action === "1" ? num : -num;
      this.form1.count = recordNum;

      this.submitting = true;
      let updateGoods = { id: this.currentRow.id };

      if (this.form1.action === "1") {
        updateGoods.count = this.originCount + num;
        updateGoods.surplusCount = this.originSurplus + num;
        let oldTotal = parseFloat(this.currentRow.totalPrice || 0);
        let addTotal = parseFloat(this.form1.price) * num;
        updateGoods.totalPrice = (oldTotal + addTotal).toFixed(2);
      }else {
        updateGoods.surplusCount = this.originSurplus - num;
      }

      this.$axios.post(`${this.$httpUrl}/record/save`, this.form1).then(res => {
        if (res.data.code === 200) {
          this.$axios.post(`${this.$httpUrl}/goods/update`, updateGoods).then(() => {
            this.$message.success("操作成功");
            this.inDialogVisible = false;
            this.loadPost();
          });
        } else {
          this.$message.error(res.data.msg || "操作失败");
        }
      }).finally(() => {
        this.submitting = false;
      });
    },
    doSelectUser(val) {
      this.tempUser = val;
    },
    confirmUser() {
      this.form1.username = this.tempUser.name;
      this.form1.userid = this.tempUser.id;
      this.innerVisible = false;
    },
    selectCurrentChange(val) {
      this.currentRow = val;
    },
    formatStorage(row) {
      const item = this.storageData.find(s => s.id === row.storage);
      return item ? item.name : "";
    },
    formatGoodstype(row) {
      const item = this.goodstypeData.find(t => t.id === row.goodstype);
      return item ? item.name : "";
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    resetInForm() {
      this.$refs.form1.resetFields();
    },
    del(id) {
      this.$axios.get(`${this.$httpUrl}/goods/del?id=${id}`).then(res => res.data).then(res => {
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.loadPost();
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    mod(row) {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.form = JSON.parse(JSON.stringify(row));
      });
    },
    add() {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.resetForm();
        this.form = {
          id: "", name: "", storage: "", goodstype: "", unit: "",
          price: "", count: "", surplusCount: "",
          totalPrice: "", remark: "", createTime: "", updateTime: "",
          warnNum: 10
        };
      });
    },
    inGoods() {
      if (!this.currentRow.id) {
        this.$message.warning("请先选择物品");
        return;
      }
      this.inDialogVisible = true;
      this.$nextTick(this.resetInForm);
      this.originCount = Number(this.currentRow.count) || 0;
      this.originSurplus = Number(this.currentRow.surplusCount) || 0;
      this.form1 = {
        goods: this.currentRow.id,
        goodsname: this.currentRow.name,
        unit: this.currentRow.unit || '',
        count: "",
        surplusCount: this.originSurplus,
        username: "",
        userid: "",
        adminId: this.user.id,
        remark: "",
        action: "1",
        price: ""
      };
    },
    outGoods() {
      if (!this.currentRow.id) {
        this.$message.warning("请先选择物品");
        return;
      }
      this.inDialogVisible = true;
      this.$nextTick(this.resetInForm);
      this.originCount = Number(this.currentRow.count) || 0;
      this.originSurplus = Number(this.currentRow.surplusCount) || 0;
      this.form1 = {
        goods: this.currentRow.id,
        goodsname: this.currentRow.name,
        unit: this.currentRow.unit || '',
        count: "",
        surplusCount: this.originSurplus,
        username: "",
        userid: "",
        adminId: this.user.id,
        remark: "",
        action: "2",
        price: ""
      };
    },
    selectUser() {
      this.innerVisible = true;
    },
    doSave() {
      this.saving = true;
      this.form.surplusCount = this.form.count;
      this.form.totalPrice = (parseFloat(this.form.price) * Number(this.form.count)).toFixed(2);

      // 1. 保存物品
      this.$axios.post(`${this.$httpUrl}/goods/save`, this.form).then(res => res.data).then(res => {
        if (res.code === 200) {
          let goodsId = res.data;
          let record = {
            goods: goodsId,
            goodsname: this.form.name,
            unit: this.form.unit,
            count: Number(this.form.count),
            surplusCount: this.form.count,
            username: this.user.name,
            userid: this.user.id,
            adminId: this.user.id,
            remark: "新增物品自动入库",
            action: "1",
            price: this.form.price
          };
          // 3. 调用保存记录（一定执行）
          this.$axios.post(`${this.$httpUrl}/record/addGoodsOnly`, record).then(() => {
            this.$message.success("新增成功");
            this.centerDialogVisible = false;
            this.loadPost();
          }).catch(() => {
            this.$message.error("记录保存失败");
          });
        } else {
          this.$message.error("新增失败");
        }
      }).catch(() => {
        this.$message.error("系统异常");
      }).finally(() => {
        this.saving = false;
      });
    },
    doMod() {
      this.saving = true;
      this.$axios.post(`${this.$httpUrl}/goods/update`, this.form).then(res => res.data).then(res => {
        if (res.code === 200) {
          this.$message.success("修改成功");
          this.centerDialogVisible = false;
          this.loadPost();
        } else {
          this.$message.error("修改失败");
        }
      }).finally(() => {
        this.saving = false;
      });
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.id ? this.doMod() : this.doSave();
        }
      });
    },
    handleSizeChange(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.loadPost();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadPost();
    },
    resetParam() {
      this.name = "";
      this.storage = "";
      this.goodstype = "";
      this.createMonth = "";
      this.loadPost();
    },
    loadPost() {
      this.$axios.post(`${this.$httpUrl}/goods/listPage`, {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        param: {
          name: this.name,
          goodstype: this.goodstype ?? "",
          storage: this.storage ?? "",
          createMonth: this.createMonth ?? "",
          deleted: 0
        }
      }).then(res => res.data).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
        }
      });
    },
    loadStorage() {
      this.$axios.get(`${this.$httpUrl}/storage/list`).then(res => res.data).then(res => {
        if (res.code === 200) this.storageData = res.data;
      });
    },
    loadGoodstype() {
      this.$axios.get(`${this.$httpUrl}/goodstype/list`).then(res => res.data).then(res => {
        if (res.code === 200) this.goodstypeData = res.data;
      });
    },
    async exportExcel() {
      try {
        this.$message.info("正在导出数据，请稍候...");

        // 1. 获取数据
        const res = await this.$axios.post(`${this.$httpUrl}/goods/listPage`, {
          pageSize: 9999,
          pageNum: 1,
          param: {
            name: this.name,
            goodstype: this.goodstype ?? "",
            storage: this.storage ?? "",
            createMonth: this.createMonth ?? "",
            deleted: 0
          }
        });

        if (res.data.code !== 200) {
          this.$message.error("获取数据失败");
          return;
        }

        const list = res.data.data;

        // 2. 表头
        const header = [
          "序号", "物品名", "仓库", "分类", "采购数量", "剩余数量",
          "单位", "总金额(元)", "创建时间", "更新时间", "备注"
        ];

        // 3. 自适应宽度 + 库存单元格标色（红/绿）
        let html = `
      <table border="1" cellpadding="3" cellspacing="0" style="border-collapse:collapse; table-layout:auto; font-size:12px;">
        <thead>
          <tr style="background:#f8f9fc; font-weight:bold; text-align:center;">
            ${header.map(h => `<th style="border:1px solid #333; padding:4px; white-space:nowrap;">${h}</th>`).join('')}
          </tr>
        </thead>
        <tbody>
    `;

        list.forEach((item, index) => {
          // 预警标红，正常标绿，文字统一黑色
          const surplusBgColor = (item.surplusCount <= item.warnNum)
              ? 'background-color:#ffcccc;'
              : 'background-color:#ccffcc;';

          html += `
        <tr style="text-align:center;">
          <td style="border:1px solid #333; padding:4px;">${index + 1}</td>
          <td style="border:1px solid #333; padding:4px;">${item.name || ""}</td>
          <td style="border:1px solid #333; padding:4px;">${this.formatStorage(item) || ""}</td>
          <td style="border:1px solid #333; padding:4px;">${this.formatGoodstype(item) || ""}</td>
          <td style="border:1px solid #333; padding:4px;">${item.count || 0}</td>
          <td style="border:1px solid #333; padding:4px; ${surplusBgColor} color:#000;">${item.surplusCount || 0}</td>
          <td style="border:1px solid #333; padding:4px;">${item.unit || ""}</td>
          <td style="border:1px solid #333; padding:4px;">${item.totalPrice || "0.00"}</td>
          <td style="border:1px solid #333; padding:4px; white-space:nowrap;">${this.formatDateTime(null, null, item.createTime)}</td>
          <td style="border:1px solid #333; padding:4px; white-space:nowrap;">${this.formatDateTime(null, null, item.updateTime)}</td>
          <td style="border:1px solid #333; padding:4px;">${item.remark || ""}</td>
        </tr>
      `;
        });

        html += `</tbody></table>`;

        // 4. 下载
        const blob = new Blob(['\ufeff' + html], { type: 'application/vnd.ms-excel;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `物品库存数据_${new Date().getTime()}.xls`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$message.success("导出成功！");
      } catch (err) {
        console.error(err);
        this.$message.error("导出异常：" + err.message);
      }
    },
  },
  beforeMount() {
    this.loadStorage();
    this.loadGoodstype();
    this.loadPost();
  }
};
</script>

<style scoped>
.goods-manage {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}

.search-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  background: #fff;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.search-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 200px;
}

.search-select {
  width: 150px;
}

.action-btn {
  font-size: 14px;
  border-radius: 8px;
  padding: 8px 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 16px 0;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table th.el-table__cell {
  background-color: #f8f9fc !important;
}

.el-dialog__body {
  padding: 20px 30px;
}

.el-form-item__label {
  font-weight: 500;
  color: #2c3e50;
}

.el-tag {
  font-weight: 600;
}
</style>